import { cn } from '@/lib/utils' // adjust to your actual cn import

// This file is copied code from SERVER/runtimes/widget
function ThreadMessage({ message, primaryColor, isUser }) {
  const textClass = getTextColor(primaryColor)
  return (
    <div key={message.id} className="group">
      <div className={cn('flex', isUser ? 'justify-end' : 'justify-start')}>
        <pre
          style={{
            backgroundColor: isUser ? primaryColor : undefined,
          }}
          className={cn(
            `
              max-w-[80%] rounded-2xl px-4 py-2.5 font-[inherit] text-sm
              text-wrap
            `,
            isUser
              ? [textClass, 'rounded-br-md']
              : 'rounded-bl-md bg-gray-200 text-gray-800',
            isUser && isWhite(primaryColor) && 'border border-gray-200',
          )}
        >
          <div>{message.content}</div>
          <div
            className={cn(
              'text-2xs opacity-50',
              isUser ? 'text-right' : 'text-left',
            )}
          >
            {new Date(message.created_at).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </div>
        </pre>
      </div>
    </div>
  )
}

function getTextColor(hexColor) {
  const rgb = hexToRgb(hexColor)

  if (!rgb)
    return 'text-black' // fallback

  const contrastWithWhite = getContrastRatio(rgb, [255, 255, 255])
  const contrastWithBlack = getContrastRatio(rgb, [0, 0, 0])

  // Return the text color with better contrast ratio
  return contrastWithWhite >= contrastWithBlack ? 'text-white' : 'text-black'
}

// Convert hex to RGB array
function hexToRgb(hex) {
  const cleaned = hex.replace('#', '')
  if (cleaned.length !== 6)
    return null

  const r = Number.parseInt(cleaned.slice(0, 2), 16)
  const g = Number.parseInt(cleaned.slice(2, 4), 16)
  const b = Number.parseInt(cleaned.slice(4, 6), 16)

  return [r, g, b]
}

// Convert sRGB to relative luminance (0–1)
function getLuminance([r, g, b]) {
  const srgb = [r, g, b].map((v) => {
    const c = v / 255
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4
  })

  return srgb[0] * 0.2126 + srgb[1] * 0.7152 + srgb[2] * 0.0722
}

// Contrast ratio per WCAG
function getContrastRatio(
  bgRgb,
  textRgb,
) {
  const L1 = getLuminance(bgRgb)
  const L2 = getLuminance(textRgb)
  return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05)
}

function isWhite(hexColor) {
  return (
    hexColor?.toLowerCase() === '#fff'
    || hexColor?.toLowerCase() === '#ffffff'
  )
}

export default ThreadMessage
